var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"purchase-header"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('purchase.payment.common.paymentMethod')))]),_vm._v(" "),_c('Steps',{staticClass:"d-sm-flex d-none",attrs:{"status":_vm.status}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }